import { Select, Text } from "@mantine/core";
import { DASHBOARD_EMPTY_STATE } from "../../constants";
import classes from "../AdminDashboardView/AdminDashboardView.module.css";

const parseNumber = (s) => {
  const str = String(s ?? "").trim();
  if (!str || str === "-" || str === "—") return NaN;
  const cleaned = str.replace(/,/g, "").replace(/[₹\s]/g, "").replace(/%/g, "");
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : NaN;
};

const formatNumericRankValue = (n) => {
  if (!Number.isFinite(n)) return "—";
  if (Number.isInteger(n)) return n.toLocaleString("en-IN");
  return Number(n.toFixed(2)).toLocaleString("en-IN");
};

const fmtCompactNumber = (n) => {
  const num = Number(n);
  if (!Number.isFinite(num)) return String(n ?? "");
  const sign = num < 0 ? "-" : "";
  const abs = Math.abs(num);
  if (abs >= 10000000) return `${sign}${(abs / 10000000).toFixed(2)}Cr`;
  if (abs >= 1000000) return `${sign}${(abs / 1000000).toFixed(2)}M`;
  if (abs >= 100000) return `${sign}${(abs / 100000).toFixed(2)}L`;
  if (abs >= 1000) return `${sign}${(abs / 1000).toFixed(2)}K`;
  return num.toLocaleString("en-IN");
};

const AdminRankList = ({ title, items = [], localFilters = [], localValue = "", onLocalChange = () => {} }) => {
  return (
    <div className={`${classes.card} ${classes.rankCard}`}>
      <div className={classes.rankCardHeaderRow}>
        <Text fw={600} size="sm" className={classes.rankCardTitle} lineClamp={1} title={title}>
          {title}
        </Text>
        {localFilters.length ? (
          <div className={classes.rankCardSelectWrap}>
            <Select
              size="xs"
              className={classes.compactSelect}
              value={localValue}
              onChange={(value) => onLocalChange(value || "")}
              data={localFilters.map((f) => (typeof f === "string" ? { value: f, label: f } : f))}
            />
          </div>
        ) : null}
      </div>
      {!items.length ? (
        <div className={classes.emptyState}>{DASHBOARD_EMPTY_STATE}</div>
      ) : (
      <div className={classes.rankList}>
        {items.map((item, index) => {
          const pct = Math.max(30, 100 - index * 12);
          return (
            <div key={`${item.name}-${index}`} className={classes.rankItem}>
              <div className={classes.rankRow}>
                <Text className={classes.rankName} lineClamp={1}>
                  {item.name}
                </Text>
                {(() => {
                  const exact = item?.value;
                  const numeric = typeof exact === "number" ? exact : parseNumber(exact);
                  const isPercent = typeof exact === "string" && exact.includes("%");
                  const shouldCompact =
                    !isPercent && Number.isFinite(numeric) && Math.abs(numeric) >= 100000;
                  let displayValue = "";
                  let titleAttr;
                  if (typeof exact === "number") {
                    const base = formatNumericRankValue(exact);
                    displayValue = shouldCompact ? fmtCompactNumber(numeric) : base;
                    titleAttr = shouldCompact ? base : undefined;
                  } else {
                    const exactStr = String(exact ?? "");
                    displayValue = shouldCompact ? fmtCompactNumber(numeric) : exactStr;
                    titleAttr = shouldCompact ? exactStr : undefined;
                  }
                  return (
                    <Text className={classes.rankValue} title={titleAttr}>
                      {displayValue}
                    </Text>
                  );
                })()}
              </div>
              <div className={classes.rankTrack}>
                <div className={classes.rankFill} style={{ width: `${pct}%` }} />
              </div>
            </div>
          );
        })}
      </div>
      )}
    </div>
  );
};

export default AdminRankList;